import { mapState } from 'vuex';
import { SELECTABLE_UPDATED } from '@/store/modules/selectableContext';
import { CardBlock } from '@/cms/definitions/content-types';
import { BasketSettings } from '../BasketSettings';
import OverviewCalculatorStepComponent from './OverviewCalculatorStepComponent.vue';
import { Options, Vue } from 'vue-class-component';
import store from '@/store/store';
import { path } from '../../services/NavigationService';
import { getSuggestedProductsFlow } from '../../services/SuggestProductService';
import { getMonthlyTotalPrice } from '../../services/CalculationService';
import { formatNumber } from '../../services/ValidationService';
import { hasDependentSplashProduct } from '../../services/campaignService';

@Options({
	name: 'OverviewBasketStepComponent',
	components: {
		OverviewCalculatorStepComponent,
	},
	computed: mapState<any>({
		basketCms: (state) => state.calculatorContext.basket.cms,
		basketModel: (state) => state.calculatorContext.basket.model,
	}),
	props: {
		card: Object, // Card from cms
		isValid: Boolean, // whether card is complete
	},
})
export default class OverviewBasketStepComponent extends Vue {
	card: CardBlock; // Card from cms
	isValid: boolean; // whether card is complete

	public basketCms!: BasketSettings; // settings from CMS (store)
	public basketModel!: any;

	public updateProdKey = 'updateProdKey';
	public productNames: Array<string> = [];
	public suggest: { suggestedProducts: string; discountDisplay: string } = {
		suggestedProducts: undefined,
		discountDisplay: undefined,
	};
	public suggestText: string = null;
	public suggestText1: string = null;
	public hasPrices = false;
	public hasGiftCards = false;

	private unsubscribe: Function;

	public created() {
		this.productNames = store.getters.getSelectableGroup('basket');
		this.unsubscribe = store.subscribeAction((action, state) => {
			if (action.type === SELECTABLE_UPDATED && action.payload?.group === 'basket') {
				this.productNames = store.getters.getSelectableGroup('basket');
				this.updateProdKey += '1';
				this.setSuggestText();
			}
		});
		this.setSuggestText();
	}

	public beforeDestroy() {
		this.unsubscribe();
	}

	public mounted(): void {
		addEventListener('keyup', this.moveOn);
	}

	public beforeUnmount(): void {
		removeEventListener('keyup', this.moveOn);
	}
	public moveOn(evt) {
		if (evt.keyCode === 13 && this.isValid) {
			this.nextStep();
		}
	}

	private setSuggestText() {
		this.suggestText = this.getSuggestText();
		this.suggestText1 = this.getSuggestText1();
	}
	private getSuggestText(): string {
		if (!this.basketCms.suggestProductsText) {
			return undefined;
		}
		this.suggest = getSuggestedProductsFlow(this.basketCms);
		if (!this.suggest) {
			return undefined;
		}
		return this.basketCms.suggestProductsText
			.replaceAll('¤discount', this.suggest.discountDisplay)
			.replaceAll('¤products', this.suggest.suggestedProducts);
	}
	private getSuggestText1(): string {
		if (this.suggest && this.basketCms.suggestProductsText1) {
			return this.basketCms.suggestProductsText1
				.replaceAll('¤discount', this.suggest.discountDisplay)
				.replaceAll('¤products', this.suggest.suggestedProducts);
		}
		return undefined;
	}

	public get forsikringerLink() {
		// KLK? const url = urlService.ensureCorrectLink(path + 'forsikringer');
		const url = path + 'forsikringer';
		return url;
	}

	public getMonthlyTotalPrice(monthly: boolean): string {
		return getMonthlyTotalPrice(monthly, this, this.productNames);
	}

	public getCampaignGiftCards(): string {
		// KLK SPLASH OK
		try {
			let total = 0;
			this.productNames.forEach((productName) => {
				const calculator = store.getters.getCalculator(productName);
				if (calculator?.model?.readyForBasket) {
					if (calculator.model.campaign?.splash) {
						if (calculator.cms.campaignSplashDependentActive) {
							if (!hasDependentSplashProduct()) {
								return;
							}
						}

						const amount = Number.parseInt(calculator.model.campaign.splash.trim().replace(/\D/g, ''));
						if (!Number.isNaN(amount)) {
							total += amount;
						}
					}
				}
			});

			if (total !== 0) {
				this.hasGiftCards = true;
				return formatNumber.format(total) + ' kr. gavekort';
			}
			return undefined;
		} catch (error) {
			this.hasGiftCards = false;
			return undefined;
		}
	}

	public nextStep(): void {
		this.$emit('nextStep', this.card.routePath);
	}
}
